import styled, { css } from 'styled-components';

import { LegacyButton } from '@/components/LegacyButton';

export const MoreResultsButton = styled(LegacyButton)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(4)};
    margin-bottom: ${theme.spacing(6)};
    width: 100%;

    ${theme.media.md.up} {
      width: initial;
      min-width: 214px;
    }
  `}
`;
